import Icon from "./Icon";
import { IconType } from "react-icons";

interface IconButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  icon: IconType;
  className?: string;
}

const IconButton: React.FC<IconButtonProps> = ({
  icon: IconComponent,
  className = "",
  ...rest
}) => {
  return (
    <button
      className={`w-12 h-12 p-2 border border-gray-300 rounded-[1rem] bg-white hover:bg-[#F5F4F2] active:bg-Border active:scale-95 transition-[background-color,transform] duration-150 flex items-center justify-center ${className}`}
      {...rest}
    >
      <Icon icon={IconComponent} size={24} color="#23221f" />
    </button>
  );
};

export default IconButton;
